
export const staticHolidays = [
    {
        date: "01-01",
        name: "Neujahr"
    },
    {
        date: "05-01",
        name: "Tag der Arbeit"
    },
    {
        date: "10-03",
        name: "Tag der deutschen Einheit"
    },
    {
        date: "12-25",
        name: "1. Weihnachtstag"
    },
    {
        date: "12-26",
        name: "2. Weihnachtstag"
    }
];

export const dynamicHolidays = [
    {
        date: -2,
        name: "Karfreitag"
    },
    {
        date: 1,
        name: "Ostermontag"
    },
    {
        date: 39,
        name: "Christi-Himmelfahrt"
    },
    {
        date: 50,
        name: "Pfingstmontag"
    }    
]

export const staticStateHolidays = {
    "Baden-Württemberg": [
        {
            date: "01-06",
            name: "Heilige Drei Könige"
        },
        {
            date: "11-01",
            name: "Allerheiligen"
        }
    ],
    "Bayern": [
        {
            date: "01-06",
            name: "Heilige Drei Könige"
        },
        {
            date: "08-08",
            name: "Augsburger Hohes Friedensfest"
        },
        {
            date: "08-15",
            name: "Maria Himmelfahrt"
        },
        {
            date: "11-01",
            name: "Allerheiligen"
        }
    ],
    "Berlin": [
        {
            date: "03-08",
            name: "Frauentag"
        }
    ],
    "Brandenburg": [
        {
            date: "10-31",
            name: "Reformationstag"
        }
    ],
    "Bremen": [
        {
            date: "10-31",
            name: "Reformationstag"
        }
    ],
    "Hamburg": [
        {
            date: "10-31",
            name: "Reformationstag"
        }
    ],
    "Hessen": [],
    "Mecklenburg-Vorpommern": [
        {
            date: "03-08",
            name: "Frauentag"
        },
        {
            date: "10-31",
            name: "Reformationstag"
        }
    ],
    "Niedersachsen": [
        {
            date: "10-31",
            name: "Reformationstag"
        }
    ],
    "Nordrhein-Westfalen": [
        {
            date: "11-01",
            name: "Allerheiligen"
        }
    ],
    "Rheinland-Pfalz": [
        {
            date: "11-01",
            name: "Allerheiligen"
        }
    ],
    "Saarland": [
        {
            date: "11-01",
            name: "Allerheiligen"
        }
    ],
    "Sachsen": [
        {
            date: "08-15",
            name: "Maria Himmelfahrt"
        },
        {
            date: "10-31",
            name: "Reformationstag"
        }
    ],
    "Sachsen-Anhalt": [
        {
            date: "01-06",
            name: "Heilige Drei Könige"
        },
        {
            date: "10-31",
            name: "Reformationstag"
        }
    ],
    "Schleswig-Holstein": [
        {
            date: "10-31",
            name: "Reformationstag"
        }
    ],
    "Thüringen": [
        {
            date: "09-20",
            name: "Weltkindertag"
        },
        {
            date: "10-31",
            name: "Reformationstag"
        }
    ]
}

export const dynamicStateHolidays = {
    "Baden-Württemberg": [
        {
            date: 60,
            name: "Fronleichnam"
        }
    ],
    "Bayern": [
        {
            date: 60,
            name: "Fronleichnam"
        },
        {
            date: 9999,
            name: "Buß und Bettag"
        }
    ],
    "Berlin": [],
    "Brandenburg": [],
    "Bremen": [],
    "Hamburg": [],
    "Hessen": [
        {
            date: 0,
            name: "Ostersonntag"
        },
        {
            date: 60,
            name: "Fronleichnam"
        }
    ],
    "Mecklenburg-Vorpommern": [],
    "Niedersachsen": [],
    "Nordrhein-Westfalen": [
        {
            date: 60,
            name: "Fronleichnam"
        }
    ],
    "Rheinland-Pfalz": [
        {
            date: 60,
            name: "Fronleichnam"
        }
    ],
    "Saarland": [
        {
            date: 60,
            name: "Fronleichnam"
        }
    ],
    "Sachsen": [
        {
            date: 60,
            name: "Fronleichnam"
        },
        {
            date: 9999,
            name: "Buß und Bettag"
        }
    ],
    "Sachsen-Anhalt": [],
    "Schleswig-Holstein": [],
    "Thüringen": [
        {
            date: 60,
            name: "Fronleichnam"
        }
    ]
}

